//import Grid from "@mui/material/Unstable_Grid2"; dont use it here it will break the dev server
import { demoModeAtom } from '@/global-store';
import ContentCard from '@components/ContentCard';
import MainBlogArticles from '@components/MainBlogArticles.jsx';
import ProductCards from '@components/ProductCards';
import UserTour from '@components/UserTour.jsx';
import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { IconHome2 } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

function Home() {
    console.info('Home is rendered');
    const [demoMode] = useAtom(demoModeAtom);
    const { t } = useTranslation();

    const steps = [
        {
            content: t('dashboardGuideHomeWelcome'),
            title: t('dashboardGuideTitle'),
            placement: 'center',
            target: 'body',
            disableBeacon: true
        },
        {
            target: '#header-right-section',
            content: t('dashboardGuideHomeStep1'),
            disableBeacon: true
        },
        {
            target: '#homeAreaBox',
            content: t('dashboardGuideHomeStep2'),
            placement: 'bottom',
            disableBeacon: true
        },
        {
            target: '#collapse-assist',
            content: t('dashboardGuideHomeStep3'),
            disableBeacon: true
        },
        {
            target: '#route-audit',
            content: t('dashboardGuideHomeStep4'),
            disableBeacon: true
        },
        {
            target: '#list-subheader-report',
            content: t('dashboardGuideHomeStep5'),
            disableBeacon: true
        },
        {
            target: '#collapse-report-analysis',
            content: t('dashboardGuideHomeStep6'),
            disableBeacon: true
        },
        {
            target: '#list-subheader-tools',
            content: t('dashboardGuideHomeStep7'),
            disableBeacon: true
        },
        {
            target: '#support-popup',
            content: t('dashboardGuideHomeStep8'),
            disableBeacon: true
        }
    ];

    if (demoMode) {
        return <Navigate replace={false} to='/demo' />;
    }

    return (
        <>
            <Grid xs={12} id='homeAreaBox'>
                <ContentCard h1 icon={IconHome2} title={t('homeGreeting')}>
                    <Box alignItems='stretch' display='flex' flexWrap='wrap' gap={4}>
                        <Box fontWeight={500} width='100%'>
                            {t('dashboardText1')}
                        </Box>

                        <ProductCards />
                    </Box>
                </ContentCard>
            </Grid>

            <Grid xs={12}>
                <MainBlogArticles />
            </Grid>

            <UserTour steps={steps} />
        </>
    );
}

export default Home;
